import script from "./Documents.vue?vue&type=script&setup=true&lang=ts"
export * from "./Documents.vue?vue&type=script&setup=true&lang=ts"

import "./Documents.vue?vue&type=style&index=0&id=b5f4bc6a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f4bc6a"]])

export default __exports__